import { getIntl } from '../../../../helpers/IntlInstance';

const interpolate = (message, values = {}) => (
  String(message).replace(/\{(\w+)\}/g, (match, key) => (
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match
  ))
);

const formatIntl = (idOrDefaultMessage, defaultMessageOrValues, maybeValues) => {
  const hasId = typeof maybeValues !== 'undefined'
    || (typeof defaultMessageOrValues === 'string');

  const id = hasId ? idOrDefaultMessage : null;
  const defaultMessage = hasId ? defaultMessageOrValues : idOrDefaultMessage;
  const values = hasId ? (maybeValues || {}) : (defaultMessageOrValues || {});

  try {
    const intl = getIntl();
    const translated = id && intl?.messages ? intl.messages[id] : null;
    return interpolate(translated || defaultMessage || idOrDefaultMessage || '', values);
  } catch {
    return interpolate(defaultMessage || idOrDefaultMessage || '', values);
  }
};

export default formatIntl;
